import { gh, isExecute, vueDefineComponent } from '@syncfusion/ej2-vue-base';
import { isNullOrUndefined } from '@syncfusion/ej2-base';
export let StockChartPeriodsDirective = vueDefineComponent({
    inject: { custom: { default: null } },
    render(createElement) {
        if (!isExecute) {
            let h = !isExecute ? gh : createElement;
            let slots = null;
            if (!isNullOrUndefined(this.$slots.default)) {
                slots = !isExecute ? this.$slots.default() : this.$slots.default;
            }
            return h('div', { class: 'e-directive' }, slots);
        }
        return;
    },
    updated() {
        if (!isExecute && this.custom) {
            this.custom();
        }
    },
    methods: {
        getTag() {
            return 'e-stockchart-periods';
        }
    }
});
export const StockChartPeriodsPlugin = {
    name: 'e-stockchart-periods',
    install(Vue) {
        Vue.component(StockChartPeriodsPlugin.name, StockChartPeriodsDirective);
    }
};
export let StockChartPeriodDirective = vueDefineComponent({
    render() {
        return;
    },
    methods: {
        getTag() {
            return 'e-stockchart-period';
        }
    }
});
export const StockChartPeriodPlugin = {
    name: 'e-stockchart-period',
    install(Vue) {
        Vue.component(StockChartPeriodPlugin.name, StockChartPeriodDirective);
    }
};
